import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[countUp]'
})
export class CountUpDirective implements OnChanges {

  @Input('countUp') endValue = 0;
  @Input() duration = 800; // ms

  private startValue = 0;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['endValue']) {
      this.animate();
    }
  }

  animate() {
    const startTime = performance.now();

    const animateFrame = (currentTime: number) => {
      const progress = Math.min((currentTime - startTime) / this.duration, 1);

      const value = Math.floor(
        this.startValue + (this.endValue - this.startValue) * this.easeOut(progress)
      );

      this.el.nativeElement.innerText = value.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(animateFrame);
      } else {
        this.startValue = this.endValue;
      }
    };

    requestAnimationFrame(animateFrame);
  }

  easeOut(t: number) {
    return 1 - Math.pow(1 - t, 3);
  }
}
